import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, Validators, AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcessProtect } from 'src/app/model/quote/excessprotect/excessprotect.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcessProtectService } from '../excess.service';
import { ActivatedRoute } from '@angular/router';
import { AmlineService } from '../../amline/amline.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-excess-protect-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css', '../../quote.component.css']
})
export class ExcessProtectVehiclesComponent implements OnInit {
  formFields: any;
  submitted = false;
  validationMsgForPopUp = '';
  dont_have_driver_name = true;
  driver_forename = '';
  driver_surname = '';
  driver_title: string;
  helptext = '';
  quote_type: number = this.route.snapshot.params.quote_type ? this.route.snapshot.params.quote_type : 1;
  // Currently selected cover ID
  selectedCoverId: string = '';
  // The currently selected premium object (will be used in template)
  selectedPremium: any = null;

  @Input() staticData;
  @Input() modelObject;
  @Input() apiModelObject;
  @Input() authDetails;
  @Output() modelObjectUpdated = new EventEmitter<ExcessProtect>();
  @Input() excessProtectOptions: any;
  @Output() mtaFinancialsUpdated = new EventEmitter<any>();
  private drivers_list: any;
  private driversFullList: any;
  private UniqueID: any;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private _snackBar: MatSnackBar,
    private excessProtectService: ExcessProtectService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private amiln: AmlineService
  ) {
  }

  ngOnInit(): void {
    this.formFields = this.formBuilder.group({
      vehicles: this.formBuilder.array([
        this.initVehicles()
      ]),
      drivers: this.formBuilder.array([]),
      excess_protect_cover_id: ['', Validators.required]
    });
    this.handleCoverDropdownState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.apiModelObject == undefined) {
      this.modelObject = this.modelObject;
    }
    else {
      this.modelObject = this.mapApiToExcessProtect(this.apiModelObject);
    }

    if (this.apiModelObject) {
      const vehiclesFA = this.vehicles;

      //vehiclesFA.clear(); // remove initial empty group

       if (changes['apiModelObject'] && this.apiModelObject?.vehicles?.length) {
    const v = this.apiModelObject.vehicles[0];
    this.vehicles.at(0).patchValue({
      registration_number: v.registration_number,
      make: v.make,
      model: v.model,
      value: v.value,
      weight: v.weight,
      year: v.year
    });

    this.selectedCoverId = this.modelObject.excess_protect_cover_id;
  }

      // this.apiModelObject.vehicles.forEach((v: any) => {
      //   const grp = this.initVehicles();
      //   grp.patchValue({
      //     registration_number: v.registration_number,
      //     make: v.make,
      //     model: v.model,
      //     value: v.value,
      //     weight: v.weight,
      //     year: v.year
      //   });
      //   vehiclesFA.push(grp);
      // });
      // this.selectedCoverId = this.modelObject.excess_protect_cover_id;
    }
    this.updateSelectedPremium();
    this.patchValues();

    // Load MTA financials if this is an MTA quote
    if (this.modelObject.type === 3) {
      this.fetchMTAFinancials();
    }
  }
  patchValues() {
    this.formFields.patchValue({
      excess_protect_cover_id: this.modelObject.excess_protect_cover_id
    });

  }
  get f(): { [key: string]: AbstractControl } {
    return this.formFields.controls;
  }

  get vehicles(): FormArray {
    return this.formFields.get('vehicles') as FormArray;
  }

  addHorsebox() {
    this.vehicles.push(this.initVehicles());
  }
  toUppercase(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.toUpperCase();

    input.value = value;
    //this.modelObject.get('registration_number')?.setValue(value, { emitEvent: false });
  }
  createNewDriver() {
    if (!this.dont_have_driver_name) {
      if (!this.driver_title || !this.driver_forename) {
        this.validationMsgForPopUp = "Please select the title and enter driver's forename.";
        return;
      }
    } else {
      this.driver_forename = 'No name provided';
    }
    // GET UNIQUE ID FOR DRIVERS
    this.excessProtectService.getUniqueID()
      .subscribe({
        next: (response: any) => {
          if (response.meta) {
            this.UniqueID = response.meta.id;
            let data = {
              'id': response.meta.id,
              'title': this.driver_title,
              'first_name': this.driver_forename,
              'last_name': this.driver_surname,
            };
            this.drivers_list.push(data);

            let dataCtrls = this.formBuilder.group(data);

            this.driversFullList.push(dataCtrls);

            this.modalService.dismissAll();
          }
        },
        error: () => { }
      });


  }

  initVehicles() {
    return this.formBuilder.group({
      registration_number: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
    });
  }

  onkeptOvernightChange(event, vehicleIndex: number) {
    this.enablePostcodeIfKeptOvernight(event.value, vehicleIndex);
  }

  enablePostcodeIfKeptOvernight(value: any, vehicleIndex: number) {
    this.enablePostcode(value, vehicleIndex);
  }

  enablePostcode(value, vehicleIndex: number) {
    if (value == null) {
      this.vehicles.at(vehicleIndex).get('postcode').disable();
    } else {
      if (!value) {
        this.vehicles.at(vehicleIndex).get('postcode').enable();
      } else {
        this.vehicles.at(vehicleIndex).get('postcode').disable();
      }
    }

  }

  public onNoDriverNameChange(event) {
    if (event.checked) {
      this.driver_title = '';
      this.driver_forename = '';
      this.driver_surname = '';
      this.dont_have_driver_name = true;
    } else {
      this.dont_have_driver_name = false;
    }
  }

  /**
   * Get vehicle registration details using amlin APi
   * @param event 
   * @param index 
   */
  public onRegistrationNumberChange(event, index) {
    this.amiln.getVehicleDetails(event.target.value, this.authDetails)
      .subscribe({
        next: (res: any) => {
          if (res.meta) {
            this.vehicles.controls[index].patchValue({
              "make": res.meta.make,
              "model": res.meta.model,
              "value": res.meta.value,
              "weight": res.meta.weight,
              "year": res.meta.year,
            });
          }
        },
        error: (err) => {
          this._snackBar.open('Vehicle not found.', '', {
            duration: 5000,
            panelClass: 'text-danger'
          });
        },
      });

  }

  public onSubmit() {
    this.submitted = true;
    if (!this.formFields.valid) {
      return false;
    }
    let formData = this.formFields.value;
    this.modelObject.vehicles = formData.vehicles;

    //this.modelObj.drivers = formData.drivers;
    this.modelObject.vehicles.forEach((res) => {
      res.breakdown_cover = false;  // changed 06-04-2023 - need to remove btreakdown
    })


    if (this.modelObject.type == 2) {
      this.modelObject.policy_id = null;
      this.modelObject.effective_date = null;
    }
    let proposer_type = '';
    let micro_enterprise = false;

    if (this.modelObject.proposer.proposer_type == 1) {
      proposer_type = 'individual';
    }
    else if (this.modelObject.proposer.proposer_type == 2) {
      proposer_type = 'joint';
    }
    else {
      proposer_type = 'company';
    }


    if (this.modelObject.proposer.micro_enterprise == 1) {
      micro_enterprise = true;
    }


    let data = {
      "quote_data": {
        "type": this.modelObject.type,
        "attributes": this.modelObject.vehicles,
        "vehicle_details": this.modelObject.vehicles,
        // "id": (this.route.snapshot.params.id) ? this.route.snapshot.params.id : this.modelObj.id
        "id": this.modelObject.id,
        "quote_meta_id": this.modelObject.quoteMetaId,
        "broker_id": this.modelObject.broker_id,
        "company_id": this.modelObject.company_id,
        "sequence_number": this.modelObject.sequenceNumber,
        "policy_start_date": this.modelObject.inception_date,
        "excess_protect_cover_id": this.modelObject.excess_protect_cover_id,
        "policy_ref_number": this.modelObject.policyRefNumber,
        "effective_date": this.quote_type == 3 ? this.modelObject.effectiveDate : null,
        "policy_holder": {
          "title": this.modelObject.proposer.title,
          "first_name": this.modelObject.proposer.first_name,
          "last_name": this.modelObject.proposer.last_name,
          "email": this.modelObject.proposer.email,
          "phone": this.modelObject.proposer.phone,
          "mobile": this.modelObject.proposer.mobile ? this.modelObject.proposer.mobile : '',
          "dob": this.modelObject.proposer.dob,
          "company_name": this.modelObject.proposer.company_name ? this.modelObject.proposer.company_name : '',
          "trading_name": this.modelObject.proposer.trading_name ? this.modelObject.proposer.trading_name : '',
          "proposer_type": proposer_type,
          "year": this.modelObject.proposer.year,
          "micro_enterprise": micro_enterprise,
        },
        "address": {
          "address1": this.modelObject.proposer.address.line1,
          "address2": this.modelObject.proposer.address.line2,
          "address3": this.modelObject.proposer.address.line3,
          "address4": "",
          "address5": "",
          "city": this.modelObject.proposer.address.county,
          "country": "UK",
          "postcode": this.modelObject.proposer.address.postcode,
        },
        "sms": this.modelObject.proposer.sms,
        "post": this.modelObject.proposer.post,
        "is_phone": this.modelObject.proposer.is_phone,
        "is_email": this.modelObject.proposer.is_email,
        'send_email': 0
      }
    };

    this.excessProtectService.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            if (res.result.quote_data) {
              const apiObj = res.result.quote_data.quote_versions[0];
              this.modelObject = this.mapApiToExcessProtect(apiObj);
              this.modelObjectUpdated.emit(this.modelObject);
            }
            ;
          } else {
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }
        });
  }

  /**
   * Get access token
   */
  public getAccessToken() {
    let data = {
      'client_id': environment.AMLINE_CLIENT_ID,
      'client_secret': environment.AMLINE_CLIENT_SECRET,
      'grant_type': environment.AMLINE_GRANT_TYPE,
      'scope': environment.AMLINE_SCOPE,
    }
    this.amiln.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData(response);
          }
        },
        (error) => { }
      );
  }

  /**
   * Get statis data
   * @param response 
   */
  public getStaticData(response) {
    this.amiln.getStaticData(response)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => { }
      );
  }




  removeHorseboxes(index: number) {
    this.vehicles.removeAt(index);
  }
  private mapApiToExcessProtect(api: any): ExcessProtect {
    const model = new ExcessProtect();
    if (!api) {
      return model;
    }
    model.id = api.id;
    model.type = api.type;
    model.broker_id = api.broker_id;
    model.company_id = api.company_id;
    model.sequenceNumber = api.sequence_number;
    model.policyRefNumber = api.policy_ref_number;
    model.quoteMetaId = api.quote_meta_id;
    model.excess_protect_cover_id = api.excess_protect_cover_id;

    model.inception_date = api.policy_start_date;
    model.cover_to = api.policy_end_date;
    model.effectiveDate = api.effective_date;

    // proposer
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.first_name = api.policy_holder.first_name;
    model.proposer.last_name = api.policy_holder.last_name;
    model.proposer.title = api.policy_holder.title;
    model.proposer.dob = api.policy_holder.dob;
    model.proposer.email = api.policy_holder.email;
    model.proposer.phone = api.policy_holder.phone;
    model.proposer.is_phone = api.policy_holder.is_phone;
    model.proposer.sms = api.policy_holder.sms;
    model.proposer.post = api.policy_holder.post;
    model.proposer.is_email = api.policy_holder.is_email;
    model.proposer.proposer_type = api.policy_holder.proposer_type;
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.company_name = api.policy_holder.company_name;
    model.proposer.trading_name = api.policy_holder.trading_name;
    model.proposer.year = api.policy_holder.year_of_establishment;
    model.proposer.address.line1 = api.policy_holder.address.address1;
    model.proposer.address.line2 = api.policy_holder.address.address2;
    model.proposer.address.line3 = api.policy_holder.address.address3;
    model.proposer.address.line4 = api.policy_holder.address.address4;
    model.proposer.address.county = api.policy_holder.address.city;
    model.proposer.address.postcode = api.policy_holder.address.postcode;
    model.proposer.address.country = api.policy_holder.address.country;
    model.reference = api.quote_ref_number;

    model.vehicles = api.vehicles ?? [];

    // financial details
    if (api.financial_details) {
      model.brokerAdminFee = api.financial_details.broker_admin_fee;
      model.brokerComission = api.financial_details.broker_commission;
    }

    return model;
  }

  updateSelectedPremium() {
    const selected = this.excessProtectOptions.result.find(
      (item: any) => item.id === this.selectedCoverId
    );

    this.selectedPremium = selected || null;

    if (selected) {
      this.modelObject.excess_protect_cover_id = selected.id;
    }
  }
  handleCoverDropdownState() {
    const control = this.formFields.get('excess_protect_cover_id');

    if (this.quote_type == 3 || this.modelObject.type == 3) {
      control?.disable();
    } else {
      control?.enable();
    }
  }

  showMTACalculation: boolean = false;
  isLoadingMTA: boolean = false;
  mtaFinancials: any = null;

  /**
   * Fetch MTA Financials from Backend
   * This method calls the backend API to calculate MTA adjustments
   */
  fetchMTAFinancials() {
    if (!this.modelObject.id || !this.selectedCoverId) {
      console.warn('Missing required data for MTA calculation');
      this.showMTACalculation = false;
      return;
    }

    this.isLoadingMTA = true;
    this.showMTACalculation = false;

    // Prepare request payload
    const mtaRequest = {
      quote_id: this.modelObject.id,
      quote_meta_id: this.modelObject.quoteMetaId,
      previous_policy_id: this.apiModelObject?.id, // ID of the policy being modified
      excess_protect_cover_id: this.selectedCoverId,
      effective_date: this.modelObject.effectiveDate || new Date().toISOString().split('T')[0],
      type: this.quote_type
    };

    console.log('Fetching MTA Financials:', mtaRequest);

    // Call backend service
    this.excessProtectService.calculateMTAFinancials(mtaRequest)
      .subscribe(
        (response: any) => {
          this.isLoadingMTA = false;

          if (response.success && response.mta_financials) {
            this.mtaFinancials = response.mta_financials;
            this.showMTACalculation = true;

            console.log('MTA Financials received:', this.mtaFinancials);
            this.mtaFinancialsUpdated.emit(this.mtaFinancials);
            // Show success message
            // this._snackBar.open('MTA adjustment calculated successfully', 'Close', {
            //   duration: 3000,
            //   panelClass: 'success-snackbar'
            // });
            console.log('MTA adjustment calculated successfully');
          } else {
            console.warn('No MTA financials in response');
            this.showMTACalculation = false;

            this._snackBar.open('Unable to calculate MTA adjustment', 'Close', {
              duration: 3000,
              panelClass: 'warning-snackbar'
            });
          }
        },
        (error) => {
          this.isLoadingMTA = false;
          this.showMTACalculation = false;

          console.error('Error fetching MTA financials:', error);

          this._snackBar.open('Error calculating MTA adjustment. Please try again.', 'Close', {
            duration: 5000,
            panelClass: 'error-snackbar'
          });
        }
      );
  }
  onCoverChange() {
    this.selectedCoverId = this.formFields.get('excess_protect_cover_id').value;
    this.updateSelectedPremium();
    // For MTA (type 3), fetch MTA financials from backend
    if (this.modelObject.type === 3 && this.selectedCoverId) {
      this.fetchMTAFinancials();
    }
  }
  
}
